/* eslint-disable no-param-reassign,@typescript-eslint/no-shadow,@typescript-eslint/no-unused-vars */

xplenty.directive('step', [
  '$compile',
  '$timeout',

  function ($compile, $timeout) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./step.html'),

      replace: true,

      transclude: true,

      scope: {
        step: '=ngModel',
      },

      compile(element, attrs) {
        const $stepBody = element.find('.step-body');
        $stepBody.height(0);

        return {
          pre(scope, element, attrs, controller, transcludeFn) {
            scope.step.index = scope.$parent.stepsCount();
            scope.step.isFirst = scope.step.index === 0;
            scope.step.title = scope.step.title || `Step ${scope.step.index + 1}`;
            scope.step.active = scope.step.active || false;
            scope.step.lock = scope.step.lock || false;
            scope.step.valid = scope.step.valid || false;
            scope.step.error = scope.step.error || false;
            scope.step.actionButton = scope.step.actionButton || false;
            scope.step.actionButtonText = scope.step.actionButtonText || '';
            scope.step.action = scope.step.action || null;
            scope.step.actionSubmitting = scope.step.actionSubmitting || false;

            const $stepBodyContainer = element.find('.step-body-container');

            const html = scope.step.directive ? $compile(scope.step.directive)(scope.$parent.$parent) : transcludeFn();
            $stepBodyContainer.append(html);

            let animate = false;

            const setActive = function (active) {
              if (scope.$parent && scope.$parent.animate) return;

              scope.$parent.setActive(scope.step.index, active, animate);

              if (active) {
                $timeout(function () {
                  const scrollTop = element.offset().top;
                  element.closest('.component-editor-body').animate(
                    {
                      scrollTop,
                    },
                    300,
                  );
                }, 750);
              }
              animate = true;
            };

            const setLock = function (lock) {
              // $stepBodyContainer.empty();
              // if (!lock) $stepBodyContainer.append($compile(html)(scope.$parent));
            };

            scope.toogle = function () {
              if (scope.$parent.animate) return;
              const nextIndex = scope.$parent.getNextIndex(scope.step.index);
              scope.$parent.setActive(scope.step.index, !scope.step.active, animate);
            };

            scope.next = function () {
              if (scope.$parent.animate) return;
              const nextIndex = scope.$parent.getNextIndex(scope.step.index);
              scope.$parent.setActive(scope.step.index, false);
              scope.$parent.setActive(nextIndex, true);
            };

            scope.back = function () {
              if (scope.$parent.animate) return;
              const prevIndex = scope.$parent.getPrevIndex(scope.step.index);
              scope.$parent.setActive(scope.step.index, false);
              scope.$parent.setActive(prevIndex, true);
            };

            $timeout(function () {
              scope.$watch(
                'step',
                function (newStep, oldStep) {
                  if (
                    typeof newStep.active === 'boolean' &&
                    typeof oldStep.active === 'boolean' &&
                    newStep.active !== oldStep.active
                  ) {
                    setActive(newStep.active);
                  }
                  if (
                    typeof newStep.lock === 'boolean' &&
                    typeof oldStep.lock === 'boolean' &&
                    newStep.lock !== oldStep.lock
                  ) {
                    setLock(newStep.lock);
                  }
                },
                true,
              );

              if (scope.step.active) setActive(true);
            }, 100);
          },

          post(scope, element, attrs, controller, transcludeFn) {
            if (scope.step.disable) {
              element.remove();
            } else {
              scope.$parent.addStep(scope.step.index, scope, element);
            }
          },
        };
      },
    };
  },
]);
